"use strict";

/**
 * DataDog RUM adapter - provides a logging interface compatible with the existing API
 * This replaces the dual-logging proxy and provides direct DataDog integration
 *
 * Uses getDataDogRUM() to access externalised SDK from app-shell (loaded via CDN)
 */

import { getDataDogRUM } from '../datadog/agent';
export function createDataDogAdapter() {
  return {
    addPageAction(name, attributes) {
      try {
        var _getDataDogRUM;
        (_getDataDogRUM = getDataDogRUM()) === null || _getDataDogRUM === void 0 || _getDataDogRUM.addAction(name, attributes);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") console.warn('[DataDog] addAction failed:', error);
      }
    },
    noticeError(error, customAttributes) {
      try {
        var _getDataDogRUM2;
        const errorObj = typeof error === 'string' ? new Error(error) : error;
        (_getDataDogRUM2 = getDataDogRUM()) === null || _getDataDogRUM2 === void 0 || _getDataDogRUM2.addError(errorObj, customAttributes);
      } catch (err) {
        if (process.env.NODE_ENV !== "production") console.warn('[DataDog] addError failed:', err);
      }
    },
    setCustomAttribute(key, value) {
      try {
        var _getDataDogRUM3;
        (_getDataDogRUM3 = getDataDogRUM()) === null || _getDataDogRUM3 === void 0 || _getDataDogRUM3.setGlobalContextProperty(key, value);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") console.warn('[DataDog] setGlobalContextProperty failed:', error);
      }
    }
  };
}